/* eslint-disable prettier/prettier */
/* eslint-disable arrow-parens */
import initialState from "./store";
import actions from "./actions";
import reducer from "./reducer";
import { useReducer, useCallback } from "react";
import GroupContext from "./groupContext";

const GroupContextProvider = (props) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const value = {
		groupInformation: state.groupInformation,
		locationInformation: state.locationInformation,
		currentGroup: state.currentGroup,
		setGroupInformation: useCallback((groupInformation) => {
			dispatch({ type: actions.SET_GROUP_INFORMATION, payload: groupInformation });
		}, []),
		setLocationInformation: useCallback((locationInformation) => {
			dispatch({ type: actions.SET_LOCATION_INFORMATION, payload: locationInformation });
		}, []),
		setCurrentGroup: useCallback((currentGroup) => {
			dispatch({ type: actions.SET_CURRENT_GROUP, payload: currentGroup });
		}, [])
	};

	// eslint-disable-next-line react/prop-types
	return <GroupContext.Provider value={value}>{props.children}</GroupContext.Provider>;
};

export default GroupContextProvider;
